/* Beyond Borders — homepage carousel automation v3, 2026-10-30.
 * Exactly ONE timer drives each section. No Slick autoplay conflicts.
 * Does not modify any catalog data, links, images or layout.
 */
(function(){
  'use strict';
  var INTERVAL_MS = 5000;
  var ACTION_PAUSE_MS = 7000;
  var KEYS = ['bb_just_landed','bb_trending_now','bb_bestsellers','bb_recently_viewed'];
  var interactionAt = new WeakMap();
  var subscribed = new WeakSet();
  var lastAdvancedAt = new WeakMap();
  var motion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var debug = { version: 3, intervalMs: INTERVAL_MS, sections: {}, whatmore: 'not_checked' };
  window.BeyondBordersCarouselStatus = debug;

  function currentPage() {
    return Boolean(document.body && document.body.classList.contains('template-index'));
  }

  function canAdvance() {
    return !document.hidden && !(motion && motion.matches);
  }

  function subscribe(node) {
    if (!node || subscribed.has(node)) return;
    subscribed.add(node);
    ['pointerdown','touchstart','wheel','keydown'].forEach(function(type){
      node.addEventListener(type,function(){
        interactionAt.set(node,Date.now());
      },{passive:type !== 'keydown'});
    });
  }

  function paused(node) {
    return Date.now()-(interactionAt.get(node)||0) < ACTION_PAUSE_MS;
  }

  function collect() {
    var result=[], all=document.querySelectorAll('[data-bb-autoplay-ms="5000"]');
    Array.prototype.forEach.call(all,function(el){
      if (el.classList.contains('products-carousel') && result.indexOf(el)<0) result.push(el);
    });
    KEYS.forEach(function(key){
      var container=document.querySelector('[id$="__'+key+'"]') ||
        document.querySelector('#shopify-section-'+key) ||
        document.querySelector('[id^="halo-product-block-"][id$="'+key+'"]') ||
        document.querySelector('[id^="halo-recently-viewed-block-"][id$="'+key+'"]') ||
        document.querySelector('[class*="section-block-"][class*="'+key+'"]');
      var el=container && (container.matches('.products-carousel') ?
        container : container.querySelector('.products-carousel'));
      if(el && result.indexOf(el)<0)result.push(el);
    });
    return result;
  }

  function category(el) {
    var node=el, id='';
    while(node && node!==document.body){
      id+=(node.id||'')+' '+(typeof node.className==='string'?node.className:'')+' ';
      node=node.parentElement;
    }
    for(var i=0;i<KEYS.length;i++)if(id.indexOf(KEYS[i])!==-1)return KEYS[i];
    return 'unknown_product_carousel';
  }

  function findSlick(el) {
    var j=window.jQuery || window.$;
    if(!j || !j.fn || typeof j.fn.slick!=='function' || !el.classList.contains('slick-initialized'))return null;
    try{
      var jq=j(el), instance=jq.slick('getSlick');
      return (instance && !instance.unslicked)?{jq:jq,instance:instance}:null;
    }catch(e){return null;}
  }

  function moveSlick(el) {
    if(!el.classList.contains('slick-initialized'))return false;
    var si=findSlick(el);
    if(si){
      var instance=si.instance, options=instance.options||{};
      var total=Number(instance.slideCount)||0;
      var shown=Number(options.slidesToShow)||1;
      if(total<=shown)return 'insufficient_items';
      if(instance.animating)return 'animating';
      try {
        // Do not run Slick's own timer as well as this one.
        if(options.autoplay)si.jq.slick('slickPause');
        var last=total-shown;
        if(options.infinite===false && instance.currentSlide>=last){
          si.jq.slick('slickGoTo',0);
        }else{
          si.jq.slick('slickNext');
        }
        return 'slick_next';
      }catch(e){}
    }
    var scope=el.closest('.halo-block,.section-block')||el.parentElement||el;
    var arrow=scope.querySelector('.slick-next:not(.slick-disabled)')||
      el.querySelector('.slick-next:not(.slick-disabled)');
    if(arrow){arrow.click();return 'slick_arrow_click';}
    return false;
  }

  function scrollForward(el, itemSelector) {
    if(!el || el.scrollWidth<=el.clientWidth+10)return false;
    var item=el.querySelector(itemSelector),width=item&&item.getBoundingClientRect().width;
    var gap=parseFloat(getComputedStyle(el).columnGap)||0;
    var delta=width>15?width+gap:Math.max(90,el.clientWidth*.75);
    var end=el.scrollWidth-el.clientWidth;
    if(el.scrollLeft>=end-delta*.55){
      el.scrollTo({left:0,behavior:'smooth'});
    }else{
      el.scrollBy({left:delta,behavior:'smooth'});
    }
    return true;
  }

  function moveProduct(el) {
    var si=moveSlick(el);
    if(si)return si;
    var items=el.querySelectorAll('.product:not(.slick-cloned),.slider__slide:not(.slick-cloned)');
    if(items.length<2)return 'insufficient_items';
    if(scrollForward(el,'.product,.slider__slide'))return 'native_scroll';
    var scroller=el.querySelector('.slider,[data-slider],.slick-list')||el;
    if(scroller!==el&&scrollForward(scroller,'.product,.slider__slide'))return 'inner_scroll';
    var scope=el.closest('.halo-block')||el.parentElement;
    var button=scope && scope.querySelector('.slider-button--next:not([disabled]),button[name="next"]:not([disabled])');
    if(button){button.click();return 'slider_next_button';}
    return 'no_scroll_available';
  }

  function moveBrands(){
    var el=document.querySelector('#bbd-editorial-2026 .bbd-track');
    if(!el)return;
    var root=document.getElementById('bbd-editorial-2026')||el;
    subscribe(root);
    if(paused(root))return;
    var action=scrollForward(el,'.bbd-item')?'native_scroll':'no_scroll_available';
    debug.sections['brands_to_discover']=action;
  }

  function widgetRoot() {
    return document.querySelector('[id$="__1771722792bf8565a2"]') ||
      document.getElementById('shopify-section-1771722792bf8565a2');
  }

  function isUsable(node) {
    if(!node || !node.isConnected || node.disabled)return false;
    var rect=node.getBoundingClientRect();
    return rect.width>5 && rect.height>5 &&
      getComputedStyle(node).visibility!=='hidden';
  }

  // Whatmore carousel: advance until the end, then return to the first tile.
  // Do not change other homepage carousels or video players.
  /* Read only publicly accessible Whatmore slide/scroll movement.
     The app can keep a Next arrow enabled on the final tile. */
  function whatmoreMovement(section) {
    var vals=[], roots=[section];
    section.querySelectorAll('*').forEach(function(el){
      if(el.shadowRoot) roots.push(el.shadowRoot);
    });
    for(var i=0;i<roots.length;i++){
      var root=roots[i];
      root.querySelectorAll('.swiper,.swiper-container,.slick-initialized').forEach(function(el){
        if(el.swiper) vals.push('sw:'+el.swiper.activeIndex+':'+el.swiper.translate);
        if(el.classList.contains('slick-initialized')){
          var item=el.querySelector('.slick-current');
          if(item) vals.push('sk:'+item.getAttribute('data-slick-index'));
        }
      });
      root.querySelectorAll('.swiper-wrapper,.slick-track,[class*="carousel" i],[class*="scroll" i]').forEach(function(el){
        if(vals.length>25)return;
        if(el.scrollWidth>el.clientWidth+40)
          vals.push('left:'+Math.round(el.scrollLeft)+':'+Math.round(el.scrollWidth-el.clientWidth));
        var tx=el.style && el.style.transform;
        if(tx && tx!=='none') vals.push('tx:'+tx);
      });
    }
    return vals.join('|');
  }

  function rewindWhatmore(section) {
    var roots=[section];
    section.querySelectorAll('*').forEach(function(el){
      if(el.shadowRoot) roots.push(el.shadowRoot);
    });
    for(var i=0;i<roots.length;i++){
      var root=roots[i], swiper=root.querySelector('.swiper,.swiper-container');
      if(swiper && swiper.swiper && typeof swiper.swiper.slideTo==='function'){
        swiper.swiper.slideTo(0);
        return 'swiper_to_first';
      }
      var slick=root.querySelector('.slick-initialized');
      if(slick && window.jQuery && window.jQuery.fn && window.jQuery.fn.slick){
        try {
          window.jQuery(slick).slick('slickGoTo',0);
          return 'slick_to_first';
        } catch(ignore) {}
      }
      var first=root.querySelector(
        '.swiper-pagination-bullet:first-child,.slick-dots li:first-child button,'+
        '[aria-label="Go to slide 1"],[aria-label="Go to first slide"]'
      );
      if(first && isUsable(first)){
        first.click();
        return 'pagination_first';
      }
      var scrolls=root.querySelectorAll(
        '[class*="carousel" i],[class*="slider" i],[class*="scroll" i],[role="list"]'
      );
      for(var j=0;j<scrolls.length;j++){
        var el=scrolls[j];
        if(el.scrollWidth>el.clientWidth+40 && el.scrollLeft>2){
          el.scrollTo({left:0,behavior:'smooth'});
          return 'scroll_to_first';
        }
      }
    }
    return 'app_reset_control_not_exposed';
  }

  var whatmoreLastAttempt=new WeakMap();
  function nextWhatmore() {
    var section=widgetRoot();
    if(!section)return 'widget_not_rendered';
    subscribe(section);
    if(paused(section))return 'paused_after_interaction';
    var roots=[section];
    section.querySelectorAll('*').forEach(function(el){
      if(el.shadowRoot)roots.push(el.shadowRoot);
    });

    function rewindScroll(root) {
      var scrolls=root.querySelectorAll(
        '[class*="carousel" i],[class*="slider" i],[class*="scroll" i],[role="list"]'
      );
      for(var k=0;k<scrolls.length;k++){
        var sc=scrolls[k];
        if(sc.scrollWidth<=sc.clientWidth+40 || sc.clientWidth<=100 || sc.clientHeight>=650)continue;
        // If the final tile is already visible, restart from the first tile.
        var end=sc.scrollWidth-sc.clientWidth;
        if(sc.scrollLeft>=end-5){
          sc.scrollTo({left:0,behavior:'smooth'});
          return 'scroll_reset_first';
        }
      }
      return false;
    }

    function rewindViaPagination(root) {
      var first=root.querySelector(
        '.swiper-pagination-bullet:first-child,'+
        '.slick-dots li:first-child button,'+
        '[aria-label="Go to slide 1"],'+
        '[aria-label="Go to first slide"],'+
        'button[aria-label="1 of"]'
      );
      if(first && isUsable(first)){
        first.click();
        return 'pagination_reset_first';
      }
      return false;
    }

    for(var i=0;i<roots.length;i++){
      var root=roots[i],sw=root.querySelector('.swiper,.swiper-container');
      if(sw && sw.swiper && typeof sw.swiper.slideNext==='function'){
        var inst=sw.swiper;
        if(inst.isEnd && !inst.params?.loop){
          if(typeof inst.slideTo==='function'){
            inst.slideTo(0);
            return 'swiper_reset_first';
          }
          if(typeof inst.slideToLoop==='function'){
            inst.slideToLoop(0);
            return 'swiper_reset_first';
          }
        }
        if(inst.isEnd){
          if(typeof inst.slideTo==='function'){
            inst.slideTo(0);
            return 'swiper_reset_first';
          }
        }
        inst.slideNext();
        return 'swiper_next';
      }

      // Some Whatmore layouts use Slick instead of Swiper.
      var slickTrack=root.querySelector('.slick-initialized');
      if(slickTrack && window.jQuery && window.jQuery.fn?.slick){
        try{
          var $slick=window.jQuery(slickTrack), si=$slick.slick('getSlick');
          if(si && !si.unslicked){
            var count=Number(si.slideCount)||0;
            var shown=Number(si.options.slidesToShow)||1;
            if(count>shown && si.currentSlide>=count-shown && !si.options.infinite){
              $slick.slick('slickGoTo',0);
              return 'slick_reset_first';
            }
            $slick.slick('slickNext');
            return 'slick_next';
          }
        }catch(ignore){}
      }

      var buttons=root.querySelectorAll(
        '.swiper-button-next,.slick-next,'+
        'button[aria-label*="Next" i],button[title*="Next" i],[data-next]'
      );
      var atEnd=false;
      for(var j=0;j<buttons.length;j++){
        var next=buttons[j];
        var disabled=next.disabled||
          next.getAttribute('aria-disabled')==='true'||
          next.classList.contains('swiper-button-disabled')||
          next.classList.contains('slick-disabled');
        if(disabled){atEnd=true;continue;}
        if(isUsable(next)){
          var before=whatmoreMovement(section);
          var previous=whatmoreLastAttempt.get(section);
          // If two previous ticks had the same measurable slide position,
          // this is a stuck final slide: restart instead of pressing Next again.
          if(before && previous && previous.position===before && previous.triedNext){
            var reset=rewindWhatmore(section);
            whatmoreLastAttempt.set(section,{position:'',triedNext:false});
            debug.whatmore=reset;
            return reset;
          }
          next.click();
          whatmoreLastAttempt.set(section,{position:before,triedNext:true});
          return 'next_button';
        }
      }
      if(atEnd){
        var viaPagination=rewindViaPagination(root);
        if(viaPagination)return viaPagination;
        var viaScroll=rewindScroll(root);
        if(viaScroll)return viaScroll;
      }

      var scrolls=root.querySelectorAll(
        '[class*="carousel" i],[class*="slider" i],[class*="scroll" i],[role="list"]'
      );
      for(var k=0;k<scrolls.length;k++){
        var sc=scrolls[k];
        if(sc.scrollWidth>sc.clientWidth+40 && sc.clientWidth>100 && sc.clientHeight<650){
          if(scrollForward(sc,':scope > *'))return 'native_scroll_or_reset';
        }
      }
    }
    return section.querySelector('iframe') ?
      'widget_iframe_inaccessible_from_theme' :
      'app_controls_not_exposed';
  }

  function tick() {
    if(!canAdvance() || !currentPage())return;
    collect().forEach(function(el){
      subscribe(el);
      var key=category(el);
      if(paused(el)){debug.sections[key]='paused_after_interaction';return;}
      var status=moveProduct(el);
      debug.sections[key]=status;
      if(status!=='insufficient_items'&&status!=='animating'&&status!=='no_scroll_available'){
        lastAdvancedAt.set(el,Date.now());
      }
    });
    moveBrands();
    // The video carousel is owned by Whatmore. Do not attempt to drive
    // third-party video slides through theme controls: the Whatmore widget
    // may stop at the end or expose no reliable rewind API.
    // Configure auto-swipe/continuous cycling inside Whatmore itself.
    debug.whatmore='managed_by_whatmore_app';
  }

  function start() {
    if(document.body.dataset.bbHomeAutoplayV3==='1')return;
    document.body.dataset.bbHomeAutoplayV3='1';
    tick();
    window.setInterval(tick,INTERVAL_MS);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',start,{once:true});
  }else start();
})();